(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/message-box/assets/javascripts/message-box.js') >= 0) return;  svs.modules.push('/components/components/message-box/assets/javascripts/message-box.js');

var svs = svs || {};

(function(svs) {
  'use strict';

  svs.components = svs.components || {};

  svs.components.MessageBox = function(element) {
    var keyListenerId = '';

    return {
      show: function(options) {
        var self = this;
        var messageBox = element.find('.js-message-box');
        var button;
        var i = 0;

        options.title = options.title || '';
        options.message = options.message || '';
        options.type = options.type || svs.components.MessageBox.Type.DEFAULT;

        for (i = 0; i < options.buttons.length; i++) {
          button = options.buttons[i];
          button.cssClass = 'message-box-button js-message-box-button';
          if (button.type === self.ButtonType.ABORT) {
            button.cssClass += ' js-message-box-abort';
            button.transparent = true;
            button.inverted = true;
          } else if (button.type === self.ButtonType.OK) {
            button.cssClass += ' js-message-box-ok';
            button.transparent = options.type === self.Type.ERROR;
          } else if (button.type === self.ButtonType.PAY) {
            button.cssClass += ' js-message-box-ok';
            button.focus = true;
          }

          if (options.buttons.length === 1) {
            button.cssClass += ' js-one-button';
            button.transparent = options.type === self.Type.ERROR;
            button.default = options.type === self.Type.ERROR;
            button.inverted = options.type === self.Type.INFOERROR;
          }
        }

        keyListenerId = svs.utils.keylistener.addKeyboardListener(function(event) {
          self.handleKeys(event);
        });

        if (messageBox.length > 0) {
          messageBox
            .replaceWith($(svs.components.message_box.templates.messagebox(options)).addClass('message-box-animate-start'))
            .show();
        } else {
          $(svs.components.message_box.templates.messagebox(options))
            .addClass('message-box-animate-start')
            .appendTo(element);
        }

        messageBox = element.find('.js-message-box');

        if (options.className) {
          messageBox.addClass(options.className);
          messageBox.data('customClass', options.className);
        }

        var messageBoxContainer = messageBox.find('.message-box');

        messageBoxContainer.css(
          'top',
          $(window).innerHeight() / 2 - messageBoxContainer.innerHeight() / 2
        );

        setTimeout(function() {
          messageBox.addClass('message-box-animate-started');
        }, 10);

        messageBox.on('click', '.js-message-box-button', function(e) {
          var index = $(e.currentTarget).data('index');

          self.close();

          if (options.buttons[index] && options.buttons[index].callback) {
            options.buttons[index].callback.call(
              options.buttons[index].context,
              e,
              self.getCheckboxValues()
            );
          }
        });

        messageBox
          .find('.js-message-box-button')
          .last()
          .focus();
      },

      getCheckboxValues: function() {
        var checkboxValues;
        var checkboxes = $('.js-message-box-checkbox');

        if (checkboxes.length > 0) {
          checkboxValues = [];

          checkboxes.each(function() {
            checkboxValues.push($(this).is(':checked'));
          });
        }

        return checkboxValues;
      },

      handleKeys: function(event) {
        var classToClick;
        var onlyOneButton = Boolean($('.js-one-button').length);

        if (event.keyCode === svs.utils.keylistener.KEY_ESC && !onlyOneButton) {
          classToClick = '.js-message-box-abort';
        } else if (event.keyCode === svs.utils.keylistener.KEY_ENTER) {
          classToClick = onlyOneButton ?
            '.js-one-button' :
            '.js-message-box-ok';
        }

        if (classToClick) {
          $(classToClick).click();
        }
      },

      close: function() {
        svs.utils.keylistener.removeKeyboardListener(keyListenerId);

        var messageBox = element.find('.js-message-box');
        if (messageBox.length !== 0) {
          messageBox
            .hide()
            .removeClass('message-box-animate-start message-box-animate-started');
          messageBox.off('click', '.js-message-box-button');
          if (messageBox.data('customClass')) {
            messageBox.removeClass(messageBox.data('customClass'));
            messageBox.removeData('customClass');
          }
        }
      }
    };
  };

  svs.components.MessageBox = new svs.components.MessageBox($('body'));

  svs.components.MessageBox.Type = {};
  svs.components.MessageBox.Type.INFO = 'info';
  svs.components.MessageBox.Type.ERROR = 'error';
  svs.components.MessageBox.Type.INFOERROR = 'infoerror';
  svs.components.MessageBox.Type.DEFAULT = svs.components.MessageBox.Type.INFO;

  svs.components.MessageBox.ButtonType = {};
  svs.components.MessageBox.ButtonType.ABORT = 0;
  svs.components.MessageBox.ButtonType.OK = 1;
  svs.components.MessageBox.ButtonType.PAY = 2;
})(svs);


 })(window);